import './App.scss';

import { IcatPlusAPIContext } from '@edata-portal/icat-plus-api';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { useEffect, useState } from 'react';
import { Col, Container, Navbar } from 'react-bootstrap';
import { Link, Route, Switch } from 'wouter';

import { CONFIG } from './config';
import { DOIPage } from './DOIPage';
import { HomePage } from './HomePage';
import { PageNotFound } from './PageNotFound';

const queryClient = new QueryClient();

function App() {
  useEffect(() => {
    document.title = `${CONFIG.SITE_NAME} DOI`;
  }, []);

  const [value] = useState(
    () =>
      ({
        baseUrl: CONFIG.ICATPLUS_URL || '',
        onError: console.error, // eslint-disable-line no-console
      }) as const,
  );

  return (
    <QueryClientProvider client={queryClient}>
      <IcatPlusAPIContext.Provider value={value}>
        <Col>
          <Navbar bg="primary" variant="dark" className="p-2">
            <Container>
              <Navbar.Brand as={Link} className="ms-0" href="/">
                {CONFIG.SITE_NAME} DOI Portal
              </Navbar.Brand>
            </Container>
          </Navbar>

          <Container className="pt-3 pb-3">
            <Switch>
              <Route path="/">
                <HomePage />
              </Route>

              {/* Alias `/doi/*` routes */}
              <Route path="/doi" nest>
                <Switch>
                  <Route path="/">
                    <HomePage />
                  </Route>
                  <Route path="/:prefix/:suffix">
                    <DOIPage />
                  </Route>
                  <Route>
                    <PageNotFound />
                  </Route>
                </Switch>
              </Route>

              <Route path="/:prefix/:suffix">
                <DOIPage />
              </Route>

              <Route>
                <PageNotFound />
              </Route>
            </Switch>
          </Container>
        </Col>
      </IcatPlusAPIContext.Provider>
    </QueryClientProvider>
  );
}

export default App;
